export var SECRIP_DETAIL = "SECRIP_DETAIL";
export var SECRIP_DETAIL_ERROR = "SECRIP_DETAIL_ERROR";
export var SECRIP_DETAIL_HIDE_ERROR = "SECRIP_DETAIL_HIDE_ERROR";
export var SECRIP_DETAIL_START_LOADER = "SECRIP_DETAIL_START_LOADER";
export var SECRIP_DETAIL_STOP_LOADER = "SECRIP_DETAIL_STOP_LOADER";
export var SCRIP_CLEAR_DATA = "SCRIP_CLEAR_DATA";
export var SCRIP_DETAILS_STREAMING = "SCRIP_DETAILS_STREAMING";
export var MARKET_DEPTH_STREAMING = "MARKET_DEPTH_STREAMING";
